import { z } from 'zod';

// Fáza 2 inzertnej sekcie (2026-07-15) — skutočné, user-submitted inzeráty majetku na
// predaj. Na rozdiel od insolvencyFeedRowSchema (read-only agregát) tu ide o zápisové
// dáta od userov, preto navyše status/moderácia. companyId a isInsolvencyRelated sú
// nezávislé, voliteľné atribúty — insolvencia je len jeden z filtrov, nie samostatná
// sekcia (viď /root/.claude/plans/abstract-finding-unicorn.md).
export const listingCategorySchema = z.enum([
  'nehnutelnosti',
  'stroje_vybavenie',
  'zasoby_tovar',
  'firmy_podiely',
  'vozidla',
  'ostatne',
]);
export type ListingCategory = z.infer<typeof listingCategorySchema>;

export const listingStatusSchema = z.enum(['pending_review', 'published', 'rejected', 'sold']);
export type ListingStatus = z.infer<typeof listingStatusSchema>;

export const listingImageSchema = z.object({
  id: z.string(),
  listingId: z.string(),
  filename: z.string(),
  sortOrder: z.number(),
});
export type ListingImage = z.infer<typeof listingImageSchema>;

export const listingRowSchema = z.object({
  id: z.string(),
  userId: z.string(),
  companyId: z.string().nullable(),
  category: listingCategorySchema,
  title: z.string(),
  description: z.string(),
  priceCents: z.number().nullable(),
  currency: z.string(),
  city: z.string().nullable(),
  isInsolvencyRelated: z.boolean(),
  status: listingStatusSchema,
  rejectionReason: z.string().nullable(),
  contactEmail: z.string(),
  contactPhone: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  publishedAt: z.string().nullable(),
  images: z.array(listingImageSchema),
  // Joined-in convenience polia pre feed (rovnaký vzor ako insolvencyFeedRowSchema).
  companyName: z.string().nullable(),
  companyIco: z.string().nullable(),
});
export type ListingRow = z.infer<typeof listingRowSchema>;

export const listingFeedResponseSchema = z.object({
  results: z.array(listingRowSchema),
  total: z.number(),
  page: z.number(),
  pageSize: z.number(),
});
export type ListingFeedResponse = z.infer<typeof listingFeedResponseSchema>;

// Vstup pri vytváraní inzerátu — validované aj na frontende (form), aj server-side
// v ListingsService (repo nemá globálny ValidationPipe, ale keďže toto vytvára
// verejný obsah, oplatí sa explicitný parse).
export const createListingInputSchema = z.object({
  category: listingCategorySchema,
  title: z.string().min(3).max(200),
  description: z.string().min(10).max(5000),
  priceCents: z.number().int().positive().nullable().optional(),
  currency: z.string().default('EUR').optional(),
  city: z.string().nullable().optional(),
  // IČO, nie interné companyId (UUID) — klient (company picker cez
  // GET /companies/search) pozná len IČO, backend si companyId dorieši cez
  // CompaniesService.getOrFetchByIco (rovnaký vzor ako watch, viď
  // CompaniesController.watch).
  companyIco: z.string().nullable().optional(),
  isInsolvencyRelated: z.boolean().optional(),
  contactEmail: z.string().email(),
  contactPhone: z.string().nullable().optional(),
});
export type CreateListingInput = z.infer<typeof createListingInputSchema>;
